import Vue from 'vue'
import { GET_FAMILY_SITUATIONS } from '../mutation-types.js'

export const getFamilySituations = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('family_situation')
    .then(
      (response) => {
        dispatch(GET_FAMILY_SITUATIONS, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/familySituationsActions.js